import styled from 'styled-components';

export const mobileBreakPoint = '768px';
export const onMobile = `@media only screen and (max-width: ${mobileBreakPoint}) `;
export const darkBlue = '#2E3E55';
export const darkBlueTint = '#394c67';
export const mediumBlue = '#3c567b';
export const lightBlue = '#87AAD1';
export const appBarHeight = '3.5rem';

export const IconImage = styled.img`
    width: 2.5rem;
    height: 2.5rem;
`;
